import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
//components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//api
import assinatura_api from '../../../api/assinatura_api';

//helpers
import { showMessage } from '../../../helpers/message';
import { PrintValidate, objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

function initialStateAssinatura() {
    return {
        matricula: "",
        nome: "",
        cargo: "",
    }
}
export default function Assinaturas({ permissao }) {
    //estado para armazenar a lista de todas as assinaturas
    const [assinaturas, setAssinaturas] = useState([]);

    //carrega os dados para edição de uma assinatura
    const editarAssinatura = (item) => {
        setLoading(true);
        assinatura_api.GetItem(item.id).then(response => {
            setAssinatura(response.data);
            toggleModal();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));

    }

    //estado para a edição/criação de uma assinatura
    const [assinatura, setAssinatura] = useState(initialStateAssinatura);

    //estado para abrir o modal de edição/criação de uma assinatura
    const [openModal, setOpenModal] = useState(false);

    //estado responsavel pelo loading na tela
    const [loading, setLoading] = useState(false);

    //estado responsavel por armazenar os erros nos campos
    const [errors, setErrors] = useState({});

    //Ações da tabela de assinaturas
    const actions = [];

    if (permissao == "Editar")
        actions.push(actionsTable.editar(editarAssinatura));

    //carrega a lista de todas as assinaturas 
    const loadAssinaturas = () => {
        setLoading(true);
        assinatura_api.GetList().then(response => {
            setAssinaturas(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => {
            setLoading(false);
        })
    }

    //carrega a lista de todas as assinaturas ao inicializar o componente
    useEffect(() => {
        loadAssinaturas();
    }, []);

    //responsavel por abrir e fechar o modal
    const toggleModal = () => {
        if (openModal) {
            setAssinatura(initialStateAssinatura);
            setErrors({});
        }
        setOpenModal(!openModal);
    };

    //onChange para os campos das assinaturas
    const onChangeAssinatura = (e) => {
        const { name, value } = e.target;
        setAssinatura({
            ...assinatura,
            [name]: value
        })
    }

    //adiciona/edita uma assinatura
    const addAssinatura = () => {
        const campos = [
            objCampo({ name: "nome", required: true }),
            objCampo({ name: "matricula", required: true }),
            objCampo({ name: "cargo", required: true }),
        ]
        const _errors = validarCampos(assinatura, campos);
        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        setLoading(true);
        if (assinatura.id) {
            assinatura_api.Put(assinatura).then(response => {
                loadAssinaturas();
                setAssinatura(initialStateAssinatura);
                toggleModal();
                showMessage("Sucesso", "Assinatura atualizada com sucesso", "success");
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            })
                .finally(f => setLoading(false));
        } else {
            assinatura_api.Post(assinatura).then(response => {
                loadAssinaturas();
                setAssinatura(initialStateAssinatura);
                toggleModal();
                showMessage("Sucesso", "Assinatura criada com sucesso", "success");
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            })
                .finally(f => setLoading(false));
        }
    }

    //cabeçalhos da tabela de assinaturas
    const headers = [
        { value: "Matrícula", objectValue: "matricula", align: "left" },
        { value: "Nome", objectValue: "nome", align: "left" },
        { value: "Cargo", objectValue: "cargo", align: "left" },
    ]

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>
                <ModalCustomized isOpen={openModal} toggle={toggleModal} btnAction={assinatura.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"} title={assinatura.id ? <><FontAwesomeIcon icon={faEdit} /> Editar assinatura</> : "+ Adicionar assinatura"} btnActionColor={assinatura.id ? "warning text-light" : "success"} onClickBtnAction={addAssinatura} btnClose>
                    <Row className='mb-4'>
                        <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="6">
                            <TextField invalid={errors.matricula ? true : false} maxLength={"50"} label={"* Matrícula"} name="matricula" value={assinatura.matricula} onChange={onChangeAssinatura} />
                            <PrintValidate field={"matricula"} errors={errors} />
                        </Col>
                        <Col md="12" lg="6">
                            <TextField invalid={errors.nome ? true : false} maxLength={"150"} label={"* Nome"} name="nome" value={assinatura.nome} onChange={onChangeAssinatura} />
                            <PrintValidate field={"nome"} errors={errors} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="12">
                            <TextField invalid={errors.cargo ? true : false} maxLength={"100"} label={"* Cargo"} name="cargo" value={assinatura.cargo} onChange={onChangeAssinatura} />
                            <PrintValidate field={"cargo"} errors={errors} />
                        </Col>
                    </Row>
                </ModalCustomized>
                <div className="mt-4">
                    <TabelaListagem options={{ print: false, search: true, pagination: true }} actions={actions} title={"Lista de assinaturas"} headers={headers} items={assinaturas} />
                </div>
            </MainCard>
        </>
    )

}